import { render, staticRenderFns } from "./PvModals.vue?vue&type=template&id=18144900&"
import script from "./PvModals.vue?vue&type=script&lang=js&"
export * from "./PvModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports